import ClickableTableWithPopup from '../../../components/tables/ClickableTableWithPopup';
import ButtonController from '../../../components/containers/buttonController';
import Pagination from "../../../components/common/pagination/Pagination";
import useClearFilters from '../../../hooks/filter/useClearFilters';
import { getFilteredReport } from '../../../utils/api/reportData';
import { getDynamicSelectData } from '../../../utils/api/data';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import React, { useEffect, useState } from 'react';
import { config } from '../../../config/Constants';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import './laneviewTrends.css';
import Axios from 'axios';

const LaneviewTrends = () => {
  const pageSize = 250;
  const [totalPages, setTotalPages] = useState(100);
  const [reportData, setReportData] = useState([]);
  const [rowsDisplayed, setRowsDisplayed] = useState(0);
  const [filteredReportData, setFilteredReportData] = useState([]);
  useClearFilters(); 

  // Redux state of filtered data
  const reportFilters = useSelector((state) => state.report.reportFilter);

  const fetchData = async () => {
    const currentYear = new Date().getFullYear().toString();
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const responseSelect = await getDynamicSelectData({
        selectValues:'*',
        tableName: "reports.LANEVIEW_TRENDS",
        whereField: ["CUSTOMER", "YEAR"],
        whereOperators: ["=", "="],
        whereValue: [Cookies.get("cp-cn"), currentYear],
        orderBy: "MONTH DESC, COUNT_MONTHLY_LOADS DESC",
        offset: { rowsDisplayed: rowsDisplayed, pageSize: pageSize },
      });
      setReportData({data: responseSelect});
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: 'laneviewtrend',
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData({data: response.data.report})
    };
  };

  useEffect(() => { 
    if (filteredReportData.length > 0) {
      setReportData({data: filteredReportData.slice(rowsDisplayed, rowsDisplayed + pageSize)});
    } else{  fetchData() }
  }, [filteredReportData, rowsDisplayed, pageSize])

  // Use Effect if reportFilters have been changed
  useEffect(() => {
    if ( reportFilters[0] && reportFilters[0].field !== '' && reportFilters[0].operator !== '' && reportFilters[0].value !== '') {
      filterReport();
    } else{  fetchData(); setTotalPages(100); }
  }, [reportFilters]);

  // UseEffect calls function if filtered data to re-render report
  const filterReport = async() => {
    const filteredData = await getFilteredReport('laneviewtrend', Cookies.get('cp-cn'), reportFilters);
    setFilteredReportData(filteredData);
    setTotalPages(Math.ceil(filteredData.length / pageSize));
  }

  const fetchExtraDetails = async (row) => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
        params: {
          reportName: 'laneviewtrenddetails', year: row.YEAR, month: row.MONTH,
          customer: row.CUSTOMER, carrier: row.CARRIER, destzip: row.DEST_ZIP,
          originzip: row.ORIGIN_ZIP
        }
      });
      return response.data.report;
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: 'laneviewtrendsextradetail',
        companyName: Cookies.get("cp-cn"),
      },
    });
      return response.data.report
    };
  };

  const handlePageChange = (event, newPage) => {
    setRowsDisplayed((newPage - 1) * pageSize);
  };

  return (
    <div className='laneviewTrendsPage'> 
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="laneviewTrendsPageContent">
          <div className="laneviewTrendsTop">
            <div className="laneviewTrendsTitle">
              <h1>Laneview Trends</h1>
            </div>
          </div>
          <div className="laneviewTrendsMid">
            <div className="lvtreportSpace">
              <div className="report">
                <ClickableTableWithPopup dataObject={reportData} onRowClick={fetchExtraDetails} />
              </div>
              <div className="reportButtons">
                <div className="paginationContainer">
                  {/* <Pagination totalPages={totalPages} onPageChange={handlePageChange} boundaryCount={2}/> */}
                </div>
                <div>
                  <ButtonController reportName={'Laneview Trends'}/>
                </div>
              </div>
            </div>
          </div>
          <div className="laneviewTrendsBottom"></div>
        </div>
      </div>
    </div>
  )
}

export default LaneviewTrends